import { get } from 'lodash';
import { useCallback, useEffect } from 'react';

import isomorphicLocalStorage from 'modules/isomorphic-local-storage';
import { useRobots } from 'queries/search/use-robots';

const LS_CACHE_KEY = 'VULNERS_ROBOT_TYPES';

export default function useGetRobotName() {
    const { data, isPlaceholderData } = useRobots({
        placeholderData: () => {
            const cached = isomorphicLocalStorage.getItem(LS_CACHE_KEY);
            if (cached) {
                try {
                    return JSON.parse(cached);
                } catch (error) {
                    console.warn(error);
                }
            }
        }
    });

    useEffect(() => {
        if (data && isPlaceholderData === false) {
            isomorphicLocalStorage.setItem(LS_CACHE_KEY, JSON.stringify(data));
        }
    }, [data, isPlaceholderData]);

    return useCallback((type: string) => get(data, [type], type), [data]);
}
